export default __webpack_public_path__ + "static/media/wotfard-extralight-webfont.0103fb78.woff2";